// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ce56740","732":"69c37938","977":"8a870817"}[chunkId] + ".chunk.js";
};